module.exports = __webpack_public_path__ + "img/11.d85586c6.jpg";